// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { controlsContainerStyles } from "@turnerBlueprint/Overrides/Widgets/ProductList/ProductListControlsContainer";
import { color, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

controlsContainerStyles.container = {
    css: css`
        width: 100%;
        padding-top: 12px;
        margin-bottom: 4px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        row-gap: 8px;
        border-top: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            flex-wrap: nowrap;
            & .hide-on-tablet {
                display: none;
            }
        }

        ${xScreen("lt", "sm")} {
            flex-wrap: wrap;
        }
    `,
};

controlsContainerStyles.leftColumn = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
        gap: 23px;
        max-width: 456px;
        & div[data-test-selector="productList_pagination"] {
            margin: 0 !important;
        }

        ${xScreen("lte", "md")} {
            max-width: unset;
            width: auto;
        }
    `,
};

controlsContainerStyles.rightColumn = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 317px;

        & div[data-test-selector="productList_pagination"] {
            margin: 0 !important;
        }

        ${xScreen("lte", "md")} {
            max-width: unset;
            width: auto;
            justify-content: flex-end;
        }
    `,
};

controlsContainerStyles.filterBtn = {
    variant: "secondary",
    sizeVariant: "small",
    css: css`
        min-width: 232px;
        ${xScreen("lt", "sm")} {
            width: 100%;
        }
    `,
};

controlsContainerStyles.tabletContainer = {
    css: css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px 16px;
        align-items: center;
        border-top: 1px solid ${color("common.border")};
        padding-top: 12px;
        .pagination-page-number {
            margin-left: auto;
        }
    `,
};
